import { MoreHorizontal } from 'lucide-react'

function extractAttribution(textLines: string[]): string[] {
  let end = textLines.length - 1
  while (end >= 0 && textLines[end].trim() === '') end--
  if (end < 0 || !/wrote:\s*$/i.test(textLines[end])) return []

  let start = end
  for (let k = 0; k < 3 && start > 0; k++) {
    if (/^On\s/.test(textLines[start])) break
    start--
  }
  if (!/^On\s/.test(textLines[start])) return []

  return textLines.slice(start)
}

export function PlainTextWithCollapsedQuotes({ text }: { text: string }) {
  const lines = text.split('\n')
  const segments: Array<{ kind: 'text' | 'quote'; lines: string[] }> = []
  let i = 0
  while (i < lines.length) {
    if (/^\s*>/.test(lines[i])) {
      const quoteLines: string[] = []
      while (i < lines.length && /^\s*>/.test(lines[i])) {
        quoteLines.push(lines[i])
        i++
      }
      const last = segments.length > 0 ? segments[segments.length - 1] : null
      if (last?.kind === 'text') {
        const attrib = extractAttribution(last.lines)
        if (attrib.length > 0) {
          last.lines = last.lines.slice(0, last.lines.length - attrib.length)
          if (last.lines.every((l) => l.trim() === '')) segments.pop()
          quoteLines.unshift(...attrib)
        }
      }
      segments.push({ kind: 'quote', lines: quoteLines })
    } else {
      const textLines: string[] = []
      while (i < lines.length && !/^\s*>/.test(lines[i])) {
        textLines.push(lines[i])
        i++
      }
      segments.push({ kind: 'text', lines: textLines })
    }
  }

  return (
    <div className="text-foreground mt-2 text-sm">
      {segments.map((seg, i) =>
        seg.kind === 'quote' ? (
          <details key={i} className="mt-2">
            <summary className="text-muted-foreground hover:text-foreground inline-flex cursor-pointer items-center rounded border border-neutral-200 bg-neutral-100 px-1.5 py-0 select-none hover:bg-neutral-200 [&::-webkit-details-marker]:hidden">
              <MoreHorizontal className="size-6" />
            </summary>
            <pre className="text-muted-foreground mt-1 font-sans wrap-anywhere whitespace-pre-wrap">
              {seg.lines.join('\n')}
            </pre>
          </details>
        ) : (
          <pre key={i} className="font-sans wrap-anywhere whitespace-pre-wrap">
            {seg.lines.join('\n')}
          </pre>
        )
      )}
    </div>
  )
}
